export enum AnimationTiming {
    Productive = "cubic-bezier(0.4, 0.0, 0.2, 1)",
    Expressive = "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
}